// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"46df8661","284":"42a50e6f","626":"6e52a5c9","651":"7f776b7c","800":"f5b626e6"}[chunkId] + ".chunk.js";
};